/* JAQUE HUE storefront behaviour: glass header, wishlist, slide cart, quick add, card swatches, collection filters,
   birthstone picker, recently viewed and product recommendations. */
(function () {
  if (window.JQ) return;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  /* toast */
  function toast(t) { let el = $('#jq-toast'); if (!el) { el = document.createElement('div'); el.id = 'jq-toast'; el.className = 'jq-toast'; el.setAttribute('role', 'status'); document.body.appendChild(el); } el.textContent = t; el.hidden = false; clearTimeout(toast.t); toast.t = setTimeout(() => (el.hidden = true), 2400); }

  /* ---------- header ---------- */
  function headerState() {
    const hd = $('.jq-header'); if (!hd) return;
    const hero = $('main .jq-underhead'); const mnav = $('#jq-mnav');
    const over = !!hero && (!mnav || mnav.hidden) && hero.getBoundingClientRect().bottom > hd.getBoundingClientRect().bottom + 8;
    hd.classList.toggle('is-over', over); hd.classList.toggle('is-ink', over && (hero.classList.contains('jq-hero--ink') || hero.classList.contains('jq-hero--campaign')));
  }
  function markNav() {
    const here = location.pathname + location.search;
    $$('.jq-hside a[href]').forEach(a => { const u = new URL(a.href, location.href); a.classList.toggle('is-on', u.pathname + u.search === here || (u.search === '' && u.pathname === location.pathname && location.search === '')); });
  }

  /* ---------- wishlist ---------- */
  const wish = new Set(store.get('jq-wish', []));
  function syncWish() {
    $$('[data-jq-wish]').forEach(b => b.setAttribute('aria-pressed', wish.has(b.dataset.jqWish)));
    $$('[data-jq-wish-count]').forEach(b => { b.textContent = wish.size || ''; b.dataset.n = wish.size; });
  }
  function toggleWish(h) { wish.has(h) ? wish.delete(h) : wish.add(h); store.set('jq-wish', [...wish]); syncWish(); toast(wish.has(h) ? 'Saved to your wishlist' : 'Removed from your wishlist'); document.dispatchEvent(new CustomEvent('jq:wish')); }

  /* ---------- cart ---------- */
  const cartSection = () => $('[data-jq-cart-section]');
  const drawer = () => $('#jq-drawer');
  let lastFocus = null;
  function setCount(n) { $$('[data-jq-cart-count]').forEach(b => { b.textContent = n || ''; b.dataset.n = n; }); }
  function applyCartHTML(html) {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('.jq-drawer__inner'); const cur = $('#jq-drawer .jq-drawer__inner');
    if (fresh && cur) cur.replaceWith(fresh);
    const n = fresh ? +fresh.dataset.count : 0; setCount(n);
    if (fresh) { applyRenders(fresh); syncInsurance(fresh).then(() => syncProtection(fresh)); }
  }
  function applyRenders(scope) {
    $$('[data-jq-render]', scope).forEach(a => { let d = null; try { d = localStorage.getItem('jq-render-' + a.dataset.jqRender); } catch (e) {} if (!d) return; let img = a.querySelector('img'); if (!img) { img = document.createElement('img'); a.appendChild(img); } img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = d; });
  }
  let insMap = null, insBusy = false;
  async function syncInsurance(inner) {
    if (insBusy || !inner.dataset.insMap) return;
    let lab = [], have = []; try { lab = JSON.parse(inner.dataset.lab || '[]'); have = JSON.parse(inner.dataset.ins || '[]'); } catch (e) { return; }
    if (!lab.length && !have.length) return;
    try {
      insBusy = true;
      if (!insMap) insMap = await (await fetch(inner.dataset.insMap)).json();
      const rate = parseFloat(inner.dataset.insRate || '5') / 100; const want = {};
      for (const l of lab) { const cents = Math.min(30000, Math.max(25, Math.round(l.p * rate / 25) * 25)); const v = insMap[cents]; if (v) want[v] = (want[v] || 0) + l.q; }
      const now = {}; have.forEach(h => (now[h.v] = (now[h.v] || 0) + h.q));
      const updates = {}; let diff = false;
      new Set([...Object.keys(want), ...Object.keys(now)]).forEach(v => { const w = want[v] || 0; if ((now[v] || 0) !== w) { updates[v] = w; diff = true; } });
      if (!diff) return;
      const add = Object.entries(updates).filter(([v, q]) => q > 0 && !now[v]);
      if (add.length) await cartPost('cart/add.js', { items: add.map(([v, q]) => ({ id: +v, quantity: q })) });
      const rest = Object.fromEntries(Object.entries(updates).filter(([v, q]) => now[v] || q === 0));
      if (Object.keys(rest).length) await cartPost('cart/update.js', { updates: rest });
    } catch (e) { /* leave the cart as it is */ } finally { insBusy = false; }
  }
  let spBusy = false;
  async function syncProtection(inner) {
    if (spBusy || !inner.dataset.spVariant) return;
    const count = inner.dataset.nonlab !== undefined ? +inner.dataset.nonlab : +inner.dataset.count, sp = +inner.dataset.spQty || 0;
    try {
      spBusy = true;
      if (count === 0 && +inner.dataset.gwQty > 0) await cartPost('cart/change.js', { id: inner.dataset.gwKey, quantity: 0 });
      else if (count === 0 && sp > 0) await cartPost('cart/change.js', { id: inner.dataset.spKey, quantity: 0 });
      else if (count > 0 && sp === 0 && inner.dataset.spDefault === 'true' && !store.get('jq-sp-off', 0)) await cartPost('cart/add.js', { items: [{ id: +inner.dataset.spVariant, quantity: 1 }] });
      else if (sp > 1) await cartPost('cart/change.js', { id: inner.dataset.spKey, quantity: 1 });
    } catch (e) { /* leave the cart as it is */ } finally { spBusy = false; }
  }
  function sectionId() { const s = cartSection(); return s ? s.dataset.jqCartSection : 'jq-cart'; }
  async function refreshCart() { const r = await fetch(`${root}?sections=${sectionId()}`); const j = await r.json(); applyCartHTML(j[sectionId()]); }
  function openCart(open) {
    const d = drawer(); if (!d) { if (open) location.href = root + 'cart'; return; }
    const scrim = $('#jq-scrim');
    if (open) lastFocus = document.activeElement;
    d.classList.toggle('is-open', open); scrim && scrim.classList.toggle('is-open', open); d.inert = !open; document.body.style.overflow = open ? 'hidden' : '';
    if (open) setTimeout(() => { const c = $('[data-jq-cart-close]', d); c && c.focus(); }, 60); else if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  async function cartPost(url, body) {
    const d = drawer(); d && d.classList.add('is-busy');
    try {
      const isForm = body instanceof FormData;
      if (isForm) { body.append('sections', sectionId()); body.append('sections_url', location.pathname); }
      else { body.sections = sectionId(); body.sections_url = location.pathname; }
      const r = await fetch(root + url, { method: 'POST', headers: isForm ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' }, body: isForm ? body : JSON.stringify(body) });
      const j = await r.json();
      if (!r.ok || j.status) throw new Error(j.description || j.message || 'Something went wrong');
      if (j.sections) applyCartHTML(j.sections[sectionId()]); else await refreshCart();
      document.dispatchEvent(new CustomEvent('jq:cart', { detail: j }));
      return j;
    } finally { d && d.classList.remove('is-busy'); }
  }
  async function addToCart(body, btn) {
    btn && btn.classList.add('is-loading');
    try { await cartPost('cart/add.js', body); openCart(true); return true; }
    catch (e) { toast(e.message); return false; }
    finally { btn && btn.classList.remove('is-loading'); }
  }

  /* ---------- clicks ---------- */
  document.addEventListener('click', async e => {
    const t = e.target.closest('button, a, [data-jq-month], [data-jq-cart-close]'); if (!t) return;
    if (t.matches('[data-jq-cart-open]')) { if (drawer()) { e.preventDefault(); openCart(true); } return; }
    if (t.matches('[data-jq-cart-close]')) { e.preventDefault(); openCart(false); return; }
    if (t.matches('#jq-menu-btn')) { const m = $('#jq-mnav'); m.hidden = !m.hidden; t.setAttribute('aria-expanded', !m.hidden); headerState(); return; }
    if (t.matches('[data-jq-wish]')) { e.preventDefault(); toggleWish(t.dataset.jqWish); return; }
    if (t.matches('[data-jq-qty]')) { const line = +t.dataset.line, q = +t.dataset.jqQty; try { await cartPost('cart/change.js', { line, quantity: q }); } catch (err) { toast(err.message); } return; }
    if (t.matches('[data-jq-add]')) { e.preventDefault(); const ok = await addToCart({ items: [{ id: +t.dataset.jqAdd, quantity: 1 }] }, t); if (ok && t.dataset.jqToast) toast(t.dataset.jqToast); return; }
    /* card swatches swap the picture and link to that variant */
    if (t.matches('.jq-card [data-jq-sw]')) {
      const card = t.closest('.jq-card'); $$('[data-jq-sw]', card).forEach(b => b.setAttribute('aria-pressed', b === t));
      const img = $('.jq-media img:not(.jq-alt)', card); if (img && t.dataset.img) { img.srcset = ''; img.src = t.dataset.img; }
      $$('a[data-jq-plink]', card).forEach(a => { const u = new URL(a.href, location.href); if (t.dataset.variant) u.searchParams.set('variant', t.dataset.variant); a.href = u.pathname + u.search; });
      const add = $('[data-jq-add]', card); if (add && t.dataset.variant) add.dataset.jqAdd = t.dataset.variant;
      return;
    }
    /* birthstone picker */
    if (t.matches('[data-jq-month]')) { const sec = t.closest('[data-jq-months]'); const i = t.dataset.jqMonth; $$('[data-jq-month]', sec).forEach(b => b.setAttribute('aria-pressed', b === t)); $$('[data-jq-mdetail]', sec).forEach(d => (d.hidden = d.dataset.jqMdetail !== i)); return; }
    /* collection */
    if (t.matches('[data-jq-cs]')) { const tr = $('[data-jq-cs-track]', t.closest('[data-jq-cslider]')); tr.scrollBy({ left: +t.dataset.jqCs * tr.clientWidth * 0.8, behavior: 'smooth' }); return; }
    if (t.matches('[data-jq-dens]')) { const n = +t.dataset.jqDens; store.set('jq-dens', n); applyDensity(t.closest('[data-jq-collection]')); return; }
    if (t.matches('[data-jq-fbtn]')) { const f = $('#jq-filters'); f.classList.toggle('is-open'); t.setAttribute('aria-expanded', f.classList.contains('is-open')); return; }
    if (t.matches('[data-jq-more]')) { e.preventDefault(); loadMore(t); return; }
    if (t.matches('a[data-jq-coll-link]')) { const c = t.closest('[data-jq-collection]'); if (c) { e.preventDefault(); collFetch(c, t.href); } return; }
    if (t.matches('[data-jq-scroll]')) { const el = document.querySelector(t.getAttribute('href')); if (el) { e.preventDefault(); scrollTo({ top: el.getBoundingClientRect().top + scrollY - 70, behavior: 'smooth' }); } return; }
  });
  document.addEventListener('change', async e => {
    const t = e.target;
    if (t.matches('[data-jq-gw]')) { const inner = t.closest('.jq-drawer__inner'); try { if (t.checked) { await cartPost('cart/add.js', { items: [{ id: +inner.dataset.gwVariant, quantity: 1 }], attributes: { 'Gift wrap': 'Yes' } }); await cartPost('cart/update.js', { attributes: { 'Gift wrap': 'Yes' } }); } else { await cartPost('cart/change.js', { id: inner.dataset.gwKey, quantity: 0 }); await cartPost('cart/update.js', { attributes: { 'Gift wrap': '' } }); } } catch (err) { toast(err.message); } return; }
    if (t.matches('[data-jq-sp]')) { const inner = t.closest('.jq-drawer__inner'); try { if (t.checked) { store.set('jq-sp-off', 0); await cartPost('cart/add.js', { items: [{ id: +inner.dataset.spVariant, quantity: 1 }] }); } else { store.set('jq-sp-off', 1); await cartPost('cart/change.js', { id: inner.dataset.spKey, quantity: 0 }); } } catch (err) { toast(err.message); } return; }
    if (t.matches('[data-jq-giftwrap]')) { try { await cartPost('cart/update.js', { attributes: { 'Gift wrap': t.checked ? 'Yes' : '' } }); } catch (err) { toast(err.message); } return; }
    const form = t.closest('form[data-jq-filter-form]'); if (form) { collSubmit(form); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && drawer() && drawer().classList.contains('is-open')) openCart(false); });
  document.addEventListener('submit', e => {
    const f = e.target;
    if (f.matches('form[data-jq-filter-form]')) { e.preventDefault(); collSubmit(f); }
  });

  /* ---------- collection ---------- */
  function applyDensity(c) {
    if (!c) return; const n = store.get('jq-dens', 3);
    $$('[data-jq-dens]', c).forEach(b => b.setAttribute('aria-pressed', +b.dataset.jqDens === n));
    const g = $('.jq-coll .jq-grid', c); g && g.style.setProperty('--cols', n === 2 ? 2 : 3);
  }
  function collSubmit(form) {
    const c = form.closest('[data-jq-collection]'); const fd = new FormData(form); const p = new URLSearchParams();
    for (const [k, v] of fd.entries()) if (v !== '') p.append(k, v);
    const url = location.pathname + (p.toString() ? '?' + p : '');
    collFetch(c, url);
  }
  async function collFetch(c, url) {
    const u = new URL(url, location.href); const sid = c.dataset.jqCollection; c.classList.add('jq-coll-loading');
    const openF = $('#jq-filters') && $('#jq-filters').classList.contains('is-open');
    try {
      const fu = new URL(u); fu.searchParams.set('section_id', sid);
      const html = await (await fetch(fu)).text(); const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-jq-collection]'); if (fresh) { c.innerHTML = fresh.innerHTML; }
      history.replaceState({}, '', u.pathname + u.search);
      if (openF) { const f = $('#jq-filters', c); f && f.classList.add('is-open'); }
      applyDensity(c); syncWish(); window.JQArt && JQArt.scan(c); init(c);
    } catch (e) { location.href = u; }
    finally { c.classList.remove('jq-coll-loading'); }
  }
  // Infinite scroll: the next page loads by itself once the shopper nears the Load more button (the button stays as a fallback).
  let moreBusy = false;
  const moreIO = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach(e => { if (e.isIntersecting && !moreBusy && e.target.isConnected) loadMore(e.target); }), { rootMargin: '0px 0px 900px 0px' }) : null;
  function watchMore() { if (moreIO) $$('[data-jq-more]').forEach(b => { if (!b.dataset.auto) { b.dataset.auto = 1; moreIO.observe(b); } }); }
  if (moreIO) { watchMore(); new MutationObserver(watchMore).observe(document.body, { childList: true, subtree: true }); }
  async function loadMore(btn) {
    if (moreBusy) return; moreBusy = true; if (moreIO) moreIO.unobserve(btn);
    const c = btn.closest('[data-jq-collection]'); btn.classList.add('is-loading');
    try {
      const u = new URL(btn.href, location.href); u.searchParams.set('section_id', c.dataset.jqCollection);
      const doc = new DOMParser().parseFromString(await (await fetch(u)).text(), 'text/html');
      const grid = $('.jq-coll .jq-grid', c);
      $$('.jq-coll .jq-grid > .jq-card', doc).forEach(card => grid.appendChild(card));
      const more = $('[data-jq-more-wrap]', doc), cur = $('[data-jq-more-wrap]', c);
      if (more && cur) cur.replaceWith(more);
      syncWish(); window.JQArt && JQArt.scan(c);
    } catch (e) { location.href = btn.href; }
    finally { btn.classList.remove('is-loading'); moreBusy = false; watchMore(); if (moreIO) $$('[data-jq-more]').forEach(b => { moreIO.unobserve(b); moreIO.observe(b); }); }
  }

  /* ---------- recently viewed / recommendations / wishlist page ---------- */
  function rememberProduct(h) { if (!h) return; const r = store.get('jq-recent', []).filter(x => x !== h); r.unshift(h); store.set('jq-recent', r.slice(0, 8)); }
  async function cardFor(handle, sid) {
    try { const r = await fetch(`${root}products/${encodeURIComponent(handle)}?sections=${sid}`); if (!r.ok) return null; const j = await r.json(); const doc = new DOMParser().parseFromString(j[sid] || '', 'text/html'); return doc.querySelector('.jq-card'); } catch (e) { return null; }
  }
  async function fillHandles(el) {
    const kind = el.dataset.jqHandles; const sid = el.dataset.cardSection || 'jq-product-card';
    let hs = kind === 'wish' ? [...wish] : store.get('jq-recent', []).filter(h => h !== el.dataset.exclude);
    hs = hs.slice(0, +(el.dataset.limit || 4));
    const wrap = el.closest('[data-jq-handles-wrap]') || el;
    const grid = $('.jq-grid', el) || el;
    if (!hs.length) { if (kind === 'wish') { grid.innerHTML = `<p class="jq-empty">${el.dataset.emptyText || 'Nothing saved yet.'}</p>`; } else wrap.hidden = true; return; }
    const cards = (await Promise.all(hs.map(h => cardFor(h, sid)))).filter(Boolean);
    grid.innerHTML = ''; cards.forEach(cd => grid.appendChild(cd)); wrap.hidden = !cards.length && kind !== 'wish'; syncWish();
  }
  async function fillRecs(el) {
    try { const r = await fetch(el.dataset.jqRecs); const html = await r.text(); const doc = new DOMParser().parseFromString(html, 'text/html'); const fresh = doc.querySelector('[data-jq-recs-body]'); const cur = $('[data-jq-recs-body]', el);
      if (fresh && cur && $('.jq-card', fresh)) { cur.replaceWith(fresh); syncWish(); } else if (!$('.jq-card', el)) el.hidden = true; } catch (e) {}
  }

  function init(scope) {
    const s = scope || document;
    syncWish(); markNav(); headerState();
    if (!scope) { const inner = $('#jq-drawer .jq-drawer__inner'); if (inner) { setCount(+inner.dataset.count || 0); applyRenders(inner); syncInsurance(inner).then(() => syncProtection(inner)); } }
    $$('[data-jq-collection]', s).forEach(applyDensity);
    $$('[data-jq-cslider]', s).forEach((cs) => {
      const tr = $('[data-jq-cs-track]', cs), prev = $('[data-jq-cs="-1"]', cs), next = $('[data-jq-cs="1"]', cs);
      const sync = () => { prev.disabled = tr.scrollLeft < 4; next.disabled = tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 4; };
      const on = $('.is-on', tr); if (on && !cs.dataset.ready) tr.scrollLeft = Math.max(0, on.offsetLeft - tr.clientWidth / 2 + on.clientWidth / 2);
      cs.dataset.ready = '1'; tr.addEventListener('scroll', sync, { passive: true }); sync();
    });
    $$('[data-jq-recent-product]', s).forEach(el => rememberProduct(el.dataset.jqRecentProduct));
    $$('[data-jq-handles]', s).forEach(fillHandles);
    $$('[data-jq-recs]', s).forEach(fillRecs);
    const pick = new URLSearchParams(location.search).get('month');
  }
  addEventListener('scroll', headerState, { passive: true });
  addEventListener('resize', headerState);
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => init()) : init();
  window.JQ = { toast, addToCart, openCart, refreshCart, cartPost, store, syncWish };
})();

// Editorial tile on collections -> ring builder.
// Browsers with cross-page view transitions: the tile picture morphs into the builder's 3D stage (names are set on both pages).
// Others: the picture grows to fill the screen with a slow ease, then the builder opens.
(() => {
  const vt = 'PageRevealEvent' in window || ('onpagereveal' in window);
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a.jq-edtile');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const bg = a.querySelector('.jq-edtile__bg');
    try { sessionStorage.setItem('jq-to-builder', '1'); } catch (err) {}
    if (vt && bg) { bg.style.viewTransitionName = 'jq-builder'; a.classList.add('is-leaving'); return; } // let the browser navigate and morph
    e.preventDefault();
    const r = a.getBoundingClientRect(), z = document.createElement('div');
    z.className = 'jq-edtile-zoom';
    Object.assign(z.style, { top: r.top + 'px', left: r.left + 'px', width: r.width + 'px', height: r.height + 'px' });
    if (bg) { const im = new Image(); im.src = bg.currentSrc || bg.src; im.alt = ''; z.appendChild(im); }
    document.body.appendChild(z);
    const l = document.createElement('link'); l.rel = 'prefetch'; l.href = a.href; document.head.appendChild(l);
    requestAnimationFrame(() => requestAnimationFrame(() => { Object.assign(z.style, { top: '0px', left: '0px', width: '100vw', height: '100vh' }); z.classList.add('is-full'); }));
    setTimeout(() => { location.href = a.href; }, 820);
  });
  addEventListener('pageshow', () => { document.querySelectorAll('.jq-edtile-zoom').forEach((z) => z.remove()); document.querySelectorAll('.jq-edtile.is-leaving').forEach((a) => { a.classList.remove('is-leaving'); const bg = a.querySelector('.jq-edtile__bg'); if (bg) bg.style.viewTransitionName = ''; }); });
})();

// Weekly offer countdown: resets every Sunday at midnight (shopper's time).
(() => {
  const els = () => document.querySelectorAll('[data-jq-weekend]'); if (!els().length) return;
  const end = () => { const d = new Date(), e = new Date(d); e.setHours(24, 0, 0, 0); e.setDate(e.getDate() + ((7 - d.getDay()) % 7)); return e; };
  const pad = (n) => String(n).padStart(2, '0');
  const tick = () => { let s = Math.max(0, Math.floor((end() - Date.now()) / 1000)); const d = Math.floor(s / 86400); s %= 86400;
    const t = (d ? d + 'd ' : '') + pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s / 60) % 60) + ':' + pad(s % 60); els().forEach((el) => (el.textContent = 'Ends in ' + t)); };
  tick(); setInterval(tick, 1000);
})();

// Fine Collection shape tabs: filter the cards in place (portal/builder cards only show under "All").
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-jq-ftabs] button'); if (!btn) return;
  const tabs = btn.parentElement, grid = tabs.nextElementSibling, cat = btn.dataset.cat;
  tabs.querySelectorAll('button').forEach((b) => b.setAttribute('aria-selected', String(b === btn)));
  grid.querySelectorAll('.jq-fcard').forEach((c) => { const cs = (c.dataset.jqCats || '').split(' '); c.hidden = cat !== 'all' && !cs.includes(cat); });
});

// Product photos: a gentle zoom (1.6x). Desktop: hover zooms toward the cursor. Touch: tap to zoom at that spot, tap again to reset.
(() => {
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const stageOf = (e) => { const st = e.target.closest('.jq-gallery .jq-stage'); return st && st.querySelector('img') && !e.target.closest('button, a') ? st : null; };
  const aim = (st, e) => { const r = st.getBoundingClientRect(), img = st.querySelector('img');
    img.style.transformOrigin = `${Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100))}% ${Math.max(0, Math.min(100, ((e.clientY - r.top) / r.height) * 100))}%`; };
  if (fine) {
    document.addEventListener('mouseover', (e) => { const st = stageOf(e); if (st && !st.classList.contains('is-zoom')) { aim(st, e); st.classList.add('is-zoom'); } });
    document.addEventListener('mousemove', (e) => { const st = stageOf(e); if (st && st.classList.contains('is-zoom')) aim(st, e); });
    document.addEventListener('mouseout', (e) => { const st = e.target.closest('.jq-gallery .jq-stage'); if (st && !st.contains(e.relatedTarget)) st.classList.remove('is-zoom'); });
  } else {
    document.addEventListener('click', (e) => { const st = stageOf(e); if (!st) return;
      document.querySelectorAll('.jq-gallery .jq-stage.is-zoom').forEach((x) => x !== st && x.classList.remove('is-zoom'));
      if (!st.classList.contains('is-zoom')) aim(st, e); st.classList.toggle('is-zoom'); });
    // swiping to the next photo resets the zoom
    document.addEventListener('scroll', (e) => { if (e.target.classList && e.target.classList.contains('jq-gallery')) e.target.querySelectorAll('.jq-stage.is-zoom').forEach((x) => x.classList.remove('is-zoom')); }, true);
  }
})();

// Cart: edit the engraving on a keepsake box or rest tray in place (same studio, same line).
document.addEventListener('click', (e) => {
  const b = e.target.closest('[data-jq-edit-ks]'); if (!b) return; e.preventDefault();
  const K = window.CJKeepsake; if (!K) { location.href = b.closest('.jq-line')?.querySelector('a[href*="/products/"]')?.href || '/'; return; }
  let props = {}; try { props = JSON.parse(b.dataset.props || '{}'); if (Array.isArray(props)) props = Object.fromEntries(props); } catch (err) { }
  const fontKey = (name) => { const n = String(name || '').toLowerCase(); return ['script', 'classic', 'modern'].find((k) => n.includes(k)) || 'classic'; };
  const values = { l1: props['Engraving'] || '', l2: props['Engraving line 2'] || '', font: fontKey(props['Lettering']), motif: props['Motif'] ? props['Motif'].toLowerCase() : 'none' };
  K.open({ mode: 'select', item: b.dataset.jqEditKs, values, view: 'lid', goLabel: 'Save changes', skipLabel: 'Cancel',
    onSave: async (v) => {
      const keep = {}; Object.keys(props).forEach((k) => { if (!['Engraving', 'Engraving line 2', 'Lettering', 'Motif'].includes(k)) keep[k] = props[k]; });
      const line = b.closest('.jq-line'); const q = +(line?.querySelector('.jq-qty span')?.textContent || 1);
      try { await window.JQ.cartPost('cart/change.js', { id: b.dataset.key, quantity: q, properties: Object.assign(keep, K.properties(v)) }); window.JQ.openCart(true); } catch (err) { window.JQ.toast && window.JQ.toast('Could not save the engraving, please try again.'); }
    } });
});
